// @core/api/endpoints/affiliate/create_affiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
  CreateAffiliateRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Register as affiliate
 * Creates a new affiliate account. Status depends on product configuration: auto-approved or pending review.
 */
export async function CreateAffiliate(
  data: CreateAffiliateRequest,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/affiliates`;
  const requestOptions = options;
  return client.post<AffiliateResponse>(requestPath, data, requestOptions);
}
